import { render, staticRenderFns } from "./NetworkStatusHeader.vue?vue&type=template&id=0bc020b0&scoped=true&"
import script from "./NetworkStatusHeader.vue?vue&type=script&lang=js&"
export * from "./NetworkStatusHeader.vue?vue&type=script&lang=js&"
import style0 from "./NetworkStatusHeader.vue?vue&type=style&index=0&id=0bc020b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc020b0",
  null
  
)

export default component.exports